export enum BackButtonIconName {
  Back = 'Back',
}

export const backButtonIconAssets: {
  [key in BackButtonIconName]: string;
} = {
  [BackButtonIconName.Back]: require('./ic-chevron-left.svg'),
};
